import { render } from "./role-permission.vue?vue&type=template&id=351e6320&scoped=true"
import script from "./role-permission.vue?vue&type=script&lang=js"
export * from "./role-permission.vue?vue&type=script&lang=js"

import "./role-permission.vue?vue&type=style&index=0&id=351e6320&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-351e6320"]])

export default __exports__